import { render, staticRenderFns } from "./RadioListItemParts.vue?vue&type=template&id=1d56fb54&scoped=true"
import script from "./RadioListItemParts.vue?vue&type=script&lang=ts"
export * from "./RadioListItemParts.vue?vue&type=script&lang=ts"
import style0 from "./RadioListItemParts.vue?vue&type=style&index=0&id=1d56fb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56fb54",
  null
  
)

export default component.exports